import classNames from 'classnames';

import styles from './RedSquigglyDivider.module.css';

import { Color } from '../../../styles';

export type DividerAlign = 'start' | 'center' | 'end';

export interface RedSquigglyDividerProps {
  variant?: 'red-squiggly';
  /** @deprecated Use `spacing` */
  margin?: number | string;
  /** The spacing between the line. Default is `13`. */
  spacing?: number | string;
  /** @deprecated Use `align` */
  justifySelf?: DividerAlign;
  /** Set the line alignment. Default is `center`. */
  align?: DividerAlign;
  className?: string;
}

const defaultSpacing = 13;
const defaultAlign = 'center';

export function RedSquigglyDivider(props: RedSquigglyDividerProps) {
  const {
    spacing = props.spacing || props.margin || defaultSpacing,
    align = props.align || props.justifySelf || defaultAlign,
  } = props;
  const className = classNames(styles.root, props.className, styles[align]);
  const style = { margin: `${spacing}px 0` };
  return (
    <div
      role="separator"
      aria-orientation="horizontal"
      className={className}
      style={style}
    >
      <svg width="120" height="3" viewBox="0 0 120 3">
        <path
          fill={Color.Carrot2}
          d="M117.658.618a.93.93 0 00-.282-.146 1.144 1.144 0 00-.336-.054c-.501-.01-1-.048-1.493-.113-.746-.067-1.428-.257-2.149-.266-1.39 0-2.793 0-4.183.057-.769.026-1.534.093-2.291.199a15.854 15.854 0 01-6.254-.18 5.452 5.452 0 00-2.214 0c-.42.077-.857.096-1.287.057A12.657 12.657 0 0093.99.105a19.45 19.45 0 01-3.243 0 18.565 18.565 0 00-3.706 0 24.74 24.74 0 00-1.763.228 9.95 9.95 0 01-4.415-.161 4.895 4.895 0 00-2.2-.086 8.632 8.632 0 01-3.861.057 7.272 7.272 0 00-1.79 0c-.926 0-1.827.162-2.74.256-.86.108-1.741.066-2.575-.123A4.381 4.381 0 0066.41.134c-3.037.142-6.035-.086-9.008-.095-.6.023-1.197.07-1.79.142-1.788.142-2.934.532-5.404 0a5.185 5.185 0 00-2.227 0c-.726.156-1.488.201-2.24.133L42.409.172a16.073 16.073 0 00-3.706.076 9.133 9.133 0 01-2.278 0 4.852 4.852 0 00-1.287 0 16.034 16.034 0 01-7.014 0 7.419 7.419 0 00-2.677 0c-1.039.192-2.12.228-3.179.104l-3.706-.18a7.048 7.048 0 00-2.24 0c-.656.142-1.376.256-2.084.37-.781.147-1.6.147-2.381 0-1-.187-2.04-.228-3.063-.124a6.449 6.449 0 01-1.802 0c-2.11-.673-4.131 0-6.177 0-.438 0-.94.361-.785.532.199.293.49.547.849.74.83.355 1.69.672 2.574.949a5.25 5.25 0 002.574.152c.708-.114 1.39-.266 2.123-.342.603-.08 1.218-.099 1.828-.057 1.238.116 2.49.132 3.732.048.302-.04.612-.04.914 0 1.647.57 3.436.275 5.25.133a17.734 17.734 0 012.356 0c1.827.113 3.642.398 5.367-.105 2.046.237 4.015-.123 6.061-.085 1.036-.02 2.069.08 3.063.294a9.217 9.217 0 003.166.095c.151-.013.302-.032.45-.057 2.601-.584 5.379-.584 7.98 0a6.081 6.081 0 002.265 0 13.228 13.228 0 014.723-.266 24.46 24.46 0 004.955.323c1.504-.18 3.038-.18 4.543 0 .457.024.917-.002 1.364-.076l3.127-.36a12.404 12.404 0 014.08.151c.417.11.848.186 1.287.228.426.054.861.054 1.287 0a5.697 5.697 0 011.847-.302c.638 0 1.268.103 1.847.302.277.069.57.095.862.076a29.615 29.615 0 015.585 0 17.82 17.82 0 004.543-.237c.424-.078.854-.135 1.287-.171a7.213 7.213 0 012.69.095 8.982 8.982 0 003.488.284c2.02.072 4.044.053 6.061-.057 1.063.014 2.124-.079 3.153-.275a3.42 3.42 0 011.699.133c.817.241 1.708.31 2.574.2a11.421 11.421 0 011.802 0 5.98 5.98 0 002.188-.152c1.287-.418 4.427 1.214 4.427-.2S117.658.618 117.658.618z"
        ></path>
      </svg>
    </div>
  );
}
